// ═══════════════════════════════════════════════════════════════
// Map Engine — Constants & Theme
// ═══════════════════════════════════════════════════════════════

import type { StatusStyle, TableIcon, TableStatus } from "./types";

export const STATUS: Record<TableStatus, StatusStyle> = {
  available: {
    bg: "#f0fdf4",
    border: "#86efac",
    color: "#22c55e",
    label: "Disponible",
  },
  blocked: {
    bg: "#f1f5f9",
    border: "#cbd5e1",
    color: "#94a3b8",
    label: "Bloqueada",
  },
  unavailable: {
    bg: "#f5f5f4",
    border: "#a8a29e",
    color: "#78716c",
    label: "No disponible",
  },
  occupied: {
    bg: "#fef2f2",
    border: "#fca5a5",
    color: "#dc2626",
    label: "Ocupada",
  },
  reserved: {
    bg: "#fefce8",
    border: "#fde047",
    color: "#ca8a04",
    label: "Reservada",
  },
  selectable: {
    bg: "#eff6ff",
    border: "#60a5fa",
    color: "#2563eb",
    label: "Disponible",
  },
  swappable: {
    bg: "#fdf4ff",
    border: "#c084fc",
    color: "#9333ea",
    label: "Intercambiar",
  },
};

export const STATUS_KEYS = Object.keys(STATUS) as TableStatus[];

export const GRID_SIZE = 30;
export const SNAP_SIZE = 15;
export const ZONE_HEADER_H = 32;
export const TABLE_BORDER_RADIUS = 10;

export const HANDLE_SIZE = 8;
export const HANDLE_HIT = 14;
export const MIN_ZONE_W = 120;
export const MIN_ZONE_H = 80;

export const ICONS: Record<TableIcon, string> = {
  baby: "\u{1F476}",
  disabled: "\u267F",
  none: "",
  outdoor: "\u{1F33F}",
  reserved: "\u{1F4CB}",
  sound: "\u{1F50A}",
  vip: "\u2B50",
  wifi: "\u{1F4F6}",
};

export const THEME = {
  // Warm cream brand background. Drops the dotted grid in favour of a
  // flat fill so the floor reads like a piece of paper instead of an
  // engineering surface.
  bg: "#fbf7ef",
  connectHighlight: "#3b82f6",
  connectionLine: "#a8a29e",
  fixedZoneSecondary: "#71717a",
  fixedZoneText: "#52525b",
  // Canvas text (mesa numbers, capacity hints, header labels) reads
  // with the brand sans so the map matches the rest of the staff app
  // and the Claude Design handoff. Falls back through ``--font-sans``
  // until ``Bw Gradual`` is available.
  font: "'Bw Gradual', system-ui, -apple-system, 'Segoe UI', sans-serif",
  // ``"transparent"`` short-circuits the dot grid: the renderer still
  // calls ``drawDotGrid`` but the dots paint with no alpha so the
  // canvas stays a clean cream surface. Kept as a string (not removed)
  // so callers in the renderer don't need a type-narrowing branch.
  gridDot: "transparent",
};
